<div class="designflow-modal-container">

  <!-- 1. Header -->
  <div class="modal-header">
    <div class="header-left">
      <h3>Create New Art Piece</h3>
    </div>

  </div>

  <div class="modal-content">

    <div class="form-grid two-col">
      <div class="mg-field">
        <span class="label-with-icon">Division Code</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-select [(ngModel)]="selectedDivisionCode" (selectionChange)="onDivisionChange($event)"
            placeholder="Select Division">
            @for (code of divisionCode; track code) {
              <mat-option [value]="code">
                {{ code.division_name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <form [formGroup]="form">
      <!-- Main Grid -->
      <div class="form-grid">

        <!-- DIVISION 9 SPECIFIC FIELDS -->
        @if (selectedDivisionCode?.divCode_id === 9) {
          <div class="mg-field">
            <span class="label-with-icon">Big Theme * <mat-icon class="info-icon" dfTooltip
            [tooltip]="'MG05'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="bigthemeControl" [matAutocomplete]="autoBigTheme">
              <mat-autocomplete #autoBigTheme="matAutocomplete" [displayWith]="displayOptionTitle">
                <mat-optgroup class="sticky-header-group">
                  <div class="dropdown-header-container">
                    <div class="dropdown-div header-row">
                      <span>MG Code</span>
                      <span class="dropdown-desc">MG Desc</span>
                    </div>
                  </div>
                </mat-optgroup>
                @for (opt of filteredOptions.bigthemeOptions; track opt) {
                  <mat-option [value]="opt">
                    <div class="dropdown-div">
                      <span>{{opt.mg_code}}</span>
                      <span class="dropdown-desc">{{opt.title}}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="mg-field">
            <span class="label-with-icon">Little Theme * <mat-icon class="info-icon" dfTooltip
            [tooltip]="'MG06'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="littleThemeControl" [matAutocomplete]="autoLittleTheme">
              <mat-autocomplete #autoLittleTheme="matAutocomplete" [displayWith]="displayOptionTitle">
                <mat-optgroup class="sticky-header-group">
                  <div class="dropdown-header-container">
                    <div class="dropdown-div header-row">
                      <span>MG Code</span>
                      <span class="dropdown-desc">MG Desc</span>
                    </div>
                  </div>
                </mat-optgroup>
                @for (opt of filteredOptions.littleThemeOptions; track opt) {
                  <mat-option [value]="opt">
                    <div class="dropdown-div">
                      <span>{{opt.mg_code}}</span>
                      <span class="dropdown-desc">{{opt.title}}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="mg-field">
            <span class="label-with-icon">Art Type <mat-icon class="info-icon" dfTooltip
            [tooltip]="'MG07'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="artTypeControl" [matAutocomplete]="autoArtType">
              <mat-autocomplete #autoArtType="matAutocomplete" [displayWith]="displayOptionTitle">
                <mat-optgroup class="sticky-header-group">
                  <div class="dropdown-header-container">
                    <div class="dropdown-div header-row">
                      <span>MG Code</span>
                      <span class="dropdown-desc">MG Desc</span>
                    </div>
                  </div>
                </mat-optgroup>
                @for (opt of filteredOptions.artTypeOptions; track opt) {
                  <mat-option [value]="opt">
                    <div class="dropdown-div">
                      <span>{{opt.mg_code}}</span>
                      <span class="dropdown-desc">{{opt.title}}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }

        <!-- NON-DIVISION 9 SPECIFIC FIELDS -->
        @if (selectedDivisionCode?.divCode_id !== 9) {
          <div class="mg-field">
            <span class="label-with-icon">Licensor * <mat-icon class="info-icon" dfTooltip
            [tooltip]="'MG05'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="licensorControl" [matAutocomplete]="autoLicensor"
                (optionSelected)="onLicensorSelected($event)">
                <mat-autocomplete #autoLicensor="matAutocomplete" [displayWith]="displayOptionTitle">
                  <mat-optgroup class="sticky-header-group">
                    <div class="dropdown-header-container">
                      <div class="dropdown-div header-row">
                        <span>MG Code</span>
                        <span class="dropdown-desc">MG Desc</span>
                      </div>
                    </div>
                  </mat-optgroup>
                  @for (opt of filteredOptions.licensorOptions; track opt) {
                    <mat-option [value]="opt">
                      <div class="dropdown-div">
                        <span>{{opt.mg_code}}</span>
                        <span class="dropdown-desc">{{opt.title}}</span>
                      </div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="mg-field">
              <span class="label-with-icon">Property * <mat-icon class="info-icon" dfTooltip
              [tooltip]="'MG06'">info</mat-icon></span>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <input matInput formControlName="propertyControl" [matAutocomplete]="autoProperty">
                <mat-autocomplete #autoProperty="matAutocomplete" [displayWith]="displayOptionTitle">
                  <mat-optgroup class="sticky-header-group">
                    <div class="dropdown-header-container">
                      <div class="dropdown-div header-row">
                        <span>MG Code</span>
                        <span class="dropdown-desc">MG Desc</span>
                      </div>
                    </div>
                  </mat-optgroup>
                  @for (opt of filteredOptions.propertyOptions; track opt) {
                    <mat-option [value]="opt">
                      <div class="dropdown-div">
                        <span>{{opt.mg_code}}</span>
                        <span class="dropdown-desc">{{opt.title}}</span>
                      </div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="mg-field">
              <span class="label-with-icon">Styleguide <mat-icon class="info-icon" dfTooltip
              [tooltip]="'MG07'">info</mat-icon></span>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <input matInput formControlName="styleguidControl" [matAutocomplete]="autoStyleguide">
                <mat-autocomplete #autoStyleguide="matAutocomplete" [displayWith]="displayOptionTitle">
                  <mat-optgroup class="sticky-header-group">
                    <div class="dropdown-header-container">
                      <div class="dropdown-div header-row">
                        <span>MG Code</span>
                        <span class="dropdown-desc">MG Desc</span>
                      </div>
                    </div>
                  </mat-optgroup>
                  @for (opt of filteredOptions.styleguidOptions; track opt) {
                    <mat-option [value]="opt">
                      <div class="dropdown-div">
                        <span>{{opt.mg_code}}</span>
                        <span class="dropdown-desc">{{opt.title}}</span>
                      </div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          }

          <!-- COMMON FIELDS -->
          <div class="mg-field">
            <span class="label-with-icon">Art Source <mat-icon class="info-icon" dfTooltip
            [tooltip]="'MG08'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="artSourceControl" [matAutocomplete]="autoArtSource">
              <mat-autocomplete #autoArtSource="matAutocomplete" [displayWith]="displayOptionTitle">
                <mat-optgroup class="sticky-header-group">
                  <div class="dropdown-header-container">
                    <div class="dropdown-div header-row">
                      <span>MG Code</span>
                      <span class="dropdown-desc">MG Desc</span>
                    </div>
                  </div>
                </mat-optgroup>
                @for (opt of filteredOptions.artSourceOptions; track opt) {
                  <mat-option [value]="opt">
                    <div class="dropdown-div">
                      <span>{{opt.mg_code}}</span>
                      <span class="dropdown-desc">{{opt.title}}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="mg-field">
            <span class="label-with-icon">Artist</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="artistControl" [matAutocomplete]="autoArtist">
              <mat-autocomplete #autoArtist="matAutocomplete" [displayWith]="displayOptionTitle">
                @for (opt of filteredOptions.artistOptions; track opt) {
                  <mat-option [value]="opt">
                    <div style="text-align: center; width: 100%;">{{opt.title}}</div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="mg-field">
            <span class="label-with-icon">Age Group <mat-icon class="info-icon" dfTooltip
            [tooltip]="'MG10'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="ageGroupControl" [matAutocomplete]="autoAgeGroup">
              <mat-autocomplete #autoAgeGroup="matAutocomplete" [displayWith]="displayOptionTitle">
                <mat-optgroup class="sticky-header-group">
                  <div class="dropdown-header-container">
                    <div class="dropdown-div header-row">
                      <span>MG Code</span>
                      <span class="dropdown-desc">MG Desc</span>
                    </div>
                  </div>
                </mat-optgroup>
                @for (opt of filteredOptions.ageGroupOptions; track opt) {
                  <mat-option [value]="opt">
                    <div class="dropdown-div">
                      <span>{{opt.mg_code}}</span>
                      <span class="dropdown-desc">{{opt.title}}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="mg-field">
            <span class="label-with-icon">Season <mat-icon class="info-icon" dfTooltip
            [tooltip]="'Season'">info</mat-icon></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="seasonControl" [matAutocomplete]="autoSeason">
              <mat-autocomplete #autoSeason="matAutocomplete" [displayWith]="displayOptionTitle">
                <mat-optgroup class="sticky-header-group">
                  <div class="dropdown-header-container">
                    <div class="dropdown-div header-row">
                      <span class="season-dropdown-width">Season Code</span>
                      <span class="dropdown-desc season-dropdown-width">Season Desc</span>
                    </div>
                  </div>
                </mat-optgroup>
                @for (opt of filteredOptions.seasonptions; track opt) {
                  <mat-option [value]="opt">
                    <div class="dropdown-div">
                      <span class="season-dropdown-width">{{opt.seasonCode}}</span>
                      <span class="dropdown-desc season-dropdown-width">{{opt.seasonDesc}}</span>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="form-grid one-col">
          <div class="mg-field">
            <span class="label-with-icon">Art Description * <mat-icon class="info-icon" dfTooltip
            [tooltip]="'Art Description'">info</mat-icon></span>
            <mat-form-field appearance="outline" class="textarea-field" subscriptSizing="dynamic">
              <textarea matInput [(ngModel)]="art_description" [ngModelOptions]="{standalone: true}" maxlength="100"
              rows="3"></textarea>
              <mat-hint align="end">{{art_description?.length || 0}} / 100</mat-hint>
            </mat-form-field>
          </div>

          <div class="mg-field">
            <span class="label-with-icon">Keywords (optional) <mat-icon class="info-icon" dfTooltip
            [tooltip]="'Press ENTER to add each tag'">info</mat-icon></span>
            <mat-form-field appearance="outline" class="tags-form-field" subscriptSizing="dynamic">
              <mat-chip-grid #chipList>
                @for (tag of tags; track tag) {
                  <mat-chip-row (removed)="tags.splice(tags.indexOf(tag),1)" class="tag-chip">
                    {{tag}}
                    <button matChipRemove><mat-icon>cancel</mat-icon></button>
                  </mat-chip-row>
                }
                <input placeholder="Add tag and press ENTER" [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="onTagInput($event)">
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>

      <!-- 3. Footer -->
      <div class="modal-footer">
        <div class="footer-left">
          <app-image-upload (uploadComplete)="onUploadComplete($event)" [value]="'image'"></app-image-upload>
        </div>

        <div class="footer-actions">
          <button mat-stroked-button mat-dialog-close (click)="resetFields(true)" [disabled]="uploading"
            [matTooltip]="uploading ? 'Please wait while the image uploads' : ''">
            Cancel
          </button>
          <button mat-flat-button color="primary" (click)="onCreateNewArtPiece()" [disabled]="uploading"
            [matTooltip]="uploading ? 'Please wait while the image uploads' : ''">
            Create Art Piece
          </button>
        </div>
      </div>

    </div>